import { render } from "./MuteIcon.svg?vue&type=template&id=09d2273e"
const script = {}
script.render = render

export default script